import React, { useState, useEffect } from 'react';

const About = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/pages');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);
  return (
    <div className='about'>
      {pages.map((page) => {
        console.log('page: ', page.slug);
        if (page.slug === 'about-us-new') {
          return <div className='inner' dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
        }
      })}
    </div>    
  );
}

export default About;